import { Box, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { getPositionMedal } from '../../../../utils/helpers';
import wlkn_coin24 from '../../../../assets/common/icons/wlkn_coin24.svg';
import { PurrformanceChartType } from '../PurrformanceCharts';
import { PurrformanceChartTooltip } from './PurrChartTooltip';
import { useDataState } from '../../../../providers/DataProvider.hooks';
import { useNavigate } from 'react-router-dom';
import { ClansStateData } from '../../../../providers/DataProvider.types';

export const PurrformanceChart = ({
    data,
    title,
    image,
    type,
}: {
    title: string;
    image: React.ReactNode;
    type: PurrformanceChartType;
    data:
        | Array<{
              name: string;
              score: string | number;
              picture?: string;
              position: number;
              clan: ClansStateData;
          }>
        | undefined;
}) => {
    const { setSelectedClan } = useDataState();
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                background: '#FFF',
                minHeight: '509px',
                borderRadius: '20px',
                marginLeft: '20px',
                overflow: 'hidden',
            }}
        >
            {data ? (
                <Box
                    sx={{
                        padding: '0 10px 10px',
                    }}
                >
                    <TableContainer>
                        <Table
                            sx={{
                                '& th': {
                                    borderBottom: 0,
                                },
                            }}
                        >
                            <TableHead>
                                <TableRow
                                    sx={{
                                        '& th': {
                                            color: '#0F0E0E',
                                            fontFamily: 'AvenirNext600',
                                            fontSize: '20px',
                                            height: '98px',
                                            padding: '0 20px',
                                            borderBottom: '1px solid #ECF0F4',
                                        },
                                    }}
                                >
                                    <TableCell colSpan={3}>
                                        <Box display={'flex'} gap={'15px'} alignItems={'center'}>
                                            {image}
                                            {title}
                                            <PurrformanceChartTooltip type={type}></PurrformanceChartTooltip>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data?.map((clanData, index) => (
                                    <TableRow
                                        key={clanData.name}
                                        sx={{
                                            '& td': {
                                                borderBottom: 0,
                                            },
                                            '&:nth-of-type(even) td': {
                                                backgroundColor: '#F6F9FC',
                                            },
                                            '&:hover': {
                                                cursor: 'pointer',
                                            },
                                        }}
                                        onClick={() => {
                                            setSelectedClan(clanData.clan);
                                            navigate('/' + clanData.clan.clan);
                                        }}
                                    >
                                        <TableCell
                                            align="center"
                                            sx={{
                                                color: '#9298A1',
                                                fontFamily: 'AvenirNext400',
                                                fontSize: '16px',
                                                lineHeight: 'normal',
                                                padding: '15px 0px 15px 10px',
                                            }}
                                        >
                                            {getPositionMedal(clanData.position, true)}
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                position: 'relative',
                                                color: '#0F0E0E',
                                                fontFamily: 'AvenirNext500',
                                                fontSize: '16px',
                                                padding: '15px',
                                            }}
                                        >
                                            <Box display={'flex'} gap={'10px'} alignItems={'center'}>
                                                <Box
                                                    sx={{
                                                        height: '48px',
                                                        minWidth: '48px',
                                                        borderRadius: '50%',
                                                        border: clanData.picture ? 'none' : '1px solid lightgrey',
                                                        display: 'inline-block',
                                                        overflow: 'hidden',
                                                        background: `url(${clanData.picture})`,
                                                        backgroundSize: 'cover',
                                                        backgroundPosition: 'center',
                                                    }}
                                                ></Box>
                                                {clanData.name}
                                            </Box>
                                        </TableCell>
                                        <TableCell align="right">
                                            <Box
                                                sx={{
                                                    color: '#0F0E0E',
                                                    fontFamily: 'AvenirNext600',
                                                    fontSize: '20px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'flex-end',
                                                    gap: '5px',
                                                }}
                                            >
                                                {type === PurrformanceChartType.WLKN_GAINED && (
                                                    <img src={wlkn_coin24} alt="walken coin"></img>
                                                )}
                                                {clanData.score}
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            ) : (
                <Skeleton variant="rounded" width={'100%'} height={'100%'} sx={{ paddingTop: '-20px' }} />
            )}
        </Box>
    );
};
